<template>
  <div>
    <table class="table">
      <thead>
        <tr>
          <th>№</th>
          <th>Название курса</th>
          <th>Вид обучения</th>
          <th class="text-center">Период</th>
          <th>Статус</th>
          <th class="progress-column text-center">Обучение</th>
          <th class="progress-column text-center">Тестирование</th>
          <th></th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(row, index) in items" :key="index" class="border-bottom border-left border-right">
          <td>{{ index + 1 }}</td>
          <td>
            <a :href="row.course_url" :style="{pointerEvents:  row.button_course_status ? 'auto' : 'none'}" class="link">{{ row.name }}</a>
          </td>
          <td class="text-nowrap">{{ row.education_type }}</td>
          <td class="text-nowrap">{{ row.date_start }} - {{ row.date_end }}</td>
          <td>{{ row.status }}</td>
          <td>
            <div style="background: rgb(0,108,255);" class="rounded">
              <div :style="{ background: 'linear-gradient(90deg, rgba(0,108,255,1)' + row.progress_slides + '%, rgba(157,157,157,1) 0%)' }"
                   class="text-center rounded white font-weight-bold">
                {{ row.progress_slides }}%
              </div>
            </div>
          </td>
          <td>
            <div style="background: rgb(0,108,255);" class="rounded" v-if="row.has_test">
              <div :style="{ background: 'linear-gradient(90deg, rgba(0,108,255,1)' + row.progress_tests + '%, rgba(157,157,157,1) 0%)' }"
                   class="text-center rounded white font-weight-bold">
                {{ row.progress_tests }}%
              </div>
            </div>
            <div style="text-align:center" v-else>
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" style=" margin:0 auto; width: 2rem; height: 2rem;" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
                <path stroke-linecap="round" stroke-linejoin="round" d="m9.75 9.75 4.5 4.5m0-4.5-4.5 4.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
              </svg>
            </div>
          </td>
          <td>
            <a :href="row.button_course_status ? row.course_url : ''">
              <button :disabled="!row.button_course_status" class="btn btn-primary">
                {{ row.button_course_text }}
              </button>
            </a>
          </td>
          <td>
            <button :disabled="!row.button_exam_status" class="btn btn-secondary" @click="examButtonHandler(row)">
              {{ row.button_exam_text }}
            </button>
          </td>
        </tr>
      </tbody>
    </table>
    <!-- Модальное окно для пин-кода -->
    <div v-if="showPinModal" class="modal">
      <div class="modal-content">
        <h3>Введите пин-код куратора</h3>
        <input v-model="enteredPinCode" type="password" placeholder="Пин-код">
        <button class="btn btn-secondary btn-modal" @click="verifyPinCode">Проверить</button>
        <button class="btn btn-secondary btn-modal" @click="closeModal">Отмена</button>
        <p v-if="pinError" class="error">Неверный пин-код, попробуйте еще раз.</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    /** @type {EducationsData[]} */
    items: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      showPinModal: false,
      enteredPinCode: '',
      pinError: false,
      selectedExam: null // хранит данные выбранного экзамена
    }
  },
  methods: {
    examButtonHandler(row) {
      if (row.exam_with_curator) {
        // Если экзамен требует куратора, показываем модальное окно
        this.selectedExam = row;
        this.showPinModal = true;
      } else {
        // Перенаправление на страницу экзамена, если куратор не требуется
        window.location.href = row.exam_url;
      }
    },
    verifyPinCode() {
      if (this.enteredPinCode === this.selectedExam.exam_pin_code) {
        // Пин-код правильный, перенаправляем на экзамен
        this.pinError = false;
        this.showPinModal = false;
        window.location.href = this.selectedExam.exam_url;
      } else {
        // Пин-код неверный, показываем сообщение об ошибке
        this.pinError = true;
      }
    },
    closeModal() {
      // Закрытие модального окна и сброс данных
      this.showPinModal = false;
      this.enteredPinCode = '';
      this.pinError = false;
      this.selectedExam = null;
    }
  }
}
</script>

<style scoped>
.table {
  width: 100%;
  border: none;
  margin-bottom: 20px;
  background-color: white;
}

.table thead th {
  font-weight: bold;
  text-align: left;
  border: none;
  padding: 10px 15px;
  background: #656565;
  color: white;
  font-size: 14px;
}

.table thead tr th:first-child {
  border-radius: 8px 0 0 0;
}

.table thead tr th:last-child {
  border-radius: 0 8px 0 0;
}

.table tbody td {
  text-align: left;
  border: none;
  padding: 10px 15px;
  font-size: 14px;
}

.table tbody tr:nth-child(even) {
  background: #e6e6e6;
}

/* Стили для ссылок */
.link {
  color: rgb(248, 108, 1);
  text-decoration: underline;
}

.progress-bar {
  position: relative;
  text-align: center;
  font-weight: bold;
  color: rgb(255, 255, 255);
  /* Цвет текста */
}

/* Стили для кнопок */
.btn {
  padding: 5px 10px;
  cursor: pointer;
  text-wrap: nowrap;
  width: 100%;
}

.btn-primary {
  background-color: rgb(248, 108, 1);
  color: white;
  border: none;
  border-radius: 4px;
}

.btn-secondary {
  background-color: rgb(248, 108, 1);
  color: white;
  border: none;
  border-radius: 4px;
}

.modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-content {
  background-color: white;
  padding: 20px;
  border-radius: 8px;
  width: 300px;
  text-align: center;
}

.btn-modal {
  margin-top: 5px;
}

.error {
  color: red;
  margin-top: 10px;
}

.progress-column {
  width: 10rem;
}

</style>
